import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuCheckboxItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { ChevronDown } from 'lucide-react';
import { UserStatus, STATUS_OPTIONS, getStatusOption } from '@/types/presence';

interface StatusFilterProps {
  selectedStatuses: UserStatus[];
  onStatusChange: (statuses: UserStatus[]) => void;
}

export const StatusFilter: React.FC<StatusFilterProps> = ({
  selectedStatuses,
  onStatusChange
}) => {
  const handleStatusToggle = (status: UserStatus, checked: boolean) => {
    if (checked) {
      onStatusChange([...selectedStatuses, status]);
    } else {
      onStatusChange(selectedStatuses.filter(s => s !== status));
    }
  };

  const clearAll = () => {
    onStatusChange([]);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="h-8">
          Statut
          {selectedStatuses.length > 0 && (
            <Badge variant="secondary" className="ml-2 h-5 px-2">
              {selectedStatuses.length}
            </Badge>
          )}
          <ChevronDown className="ml-2 h-3 w-3" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        {STATUS_OPTIONS.filter(option => option.value !== 'offline').map((option) => (
          <DropdownMenuCheckboxItem
            key={option.value}
            checked={selectedStatuses.includes(option.value)}
            onCheckedChange={(checked) => handleStatusToggle(option.value, checked)}
            className="flex items-center gap-3 py-2"
          >
            <span className="text-lg">{option.icon}</span>
            <div className="flex-1">
              <div className={`font-medium ${option.color}`}>
                {option.label}
              </div>
              <div className="text-xs text-muted-foreground">
                {option.description}
              </div>
            </div>
          </DropdownMenuCheckboxItem>
        ))}
        
        {selectedStatuses.length > 0 && (
          <>
            <div className="border-t border-border my-1" />
            <div className="p-2">
              <Button 
                variant="ghost" 
                size="sm" 
                onClick={clearAll}
                className="w-full h-7 text-xs"
              >
                Effacer tout
              </Button>
            </div>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};